<template>
  <div class="white-bg" v-loading="loading">
    <div class="flex flex-h-bet"><h3 class="bold mt-0 mb-20">Reports</h3></div>
    <div class="border">
      <div class="filters no-check relative">
        <div class="mb-20 bold flex flex-h-bet">
          <h3>Payslip</h3>
          <div class="btn-wrapper mb-10 move-right">
            <div class="inline-flex flex-v-end mr-5 ml-10">
              <el-select
                v-model="selectedFormat"
                placeholder="Export As"
                class="repo-select export"
                @change="downloadReport"
                clearable
              >
                <el-option
                  v-for="item in downloadFormats"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <button
              @click.prevent="$router.go(-1)"
              class="btn btn-full-radius mr-10 report-clear"
            >
              Clear
            </button>
          </div>
        </div>
        <div class="mb-20" v-if="isReportAvailable">
          <p class="bold mb-10 small">Date</p>
          <span
            class="block-text"
            v-if="reportParams.month && reportParams.year"
          >
            {{ `${months[reportParams.month - 1]} ${reportParams.year}` }}</span
          >
        </div>
      </div>
      <div class="border" v-if="isReportAvailable">
        <div class="report-head">
          <img src="/img/logo.svg" alt="logo" class="logo" />
        </div>

        <div class="table-title">
          <h3>
            {{ `${months[reportParams.month - 1]}, ${reportParams.year}` }}
            Payslip
          </h3>
        </div>

        <div class="flex flex-column mt-40 border-table">
          <h3 class="table-head">Personal Information</h3>
          <div class="table-head-info ">
            <div class="ml-10 border-right">
              <div class="mb-20 mt-20">
                <p class="gray-text mb-10">Employee's Name</p>
                <p>{{ reportsData.name }}</p>
              </div>
              <div class="mb-20">
                <p class="gray-text mb-10">Designation</p>
                <p>{{ reportsData.employee_designation }}</p>
              </div>
            </div>
            <div class="ml-10 border-right">
              <div class="mb-20 mt-20">
                <p class="gray-text mb-10">Department</p>
                <p>{{ reportsData.department }}</p>
              </div>
              <div class="mb-20">
                <p class="gray-text mb-10">Grade</p>
                <p>{{ reportsData.employee_grade }}</p>
              </div>
            </div>
            <div class="ml-10 mt-20">
              <p class="gray-text">Paid On</p>
              <p>NA</p>
            </div>
          </div>
        </div>

        <div class="flex flex-column mt-40 border-table">
          <div class="pay-table bold">
            <h3 class="">PAY ITEM</h3>
            <h3 class="">CURRENT PAY</h3>
            <h3 class="">YEAR TO DATE</h3>
          </div>
          <div>
            <div class="">
              <div
                class="table-info"
                v-for="allowance in reportsData.allowances &&
                  reportsData.allowances.data"
                :key="allowance.name"
              >
                <span>{{ allowance.name }}</span>
                <span>{{ currencyFormat(allowance.current_pay) }}</span>
                <span>{{ currencyFormat(allowance.year_to_date) }}</span>
              </div>
            </div>
            <div class="table-footer bold">
              <h3>Gross Salary</h3>
              <h3>
                NGN{{
                  reportsData.gross_pay &&
                    currencyFormat(reportsData.gross_pay.current_pay)
                }}
              </h3>
              <h3>
                NGN{{
                  reportsData.gross_pay &&
                    currencyFormat(reportsData.gross_pay.year_to_date)
                }}
              </h3>
            </div>
          </div>

          <div>
            <h3 class="bold m-30">Benefit</h3>
            <div
              class="table-info "
              v-for="benefit in reportsData.benefits &&
                reportsData.benefits.data"
              :key="benefit.name"
            >
              <span>{{ benefit.name }}</span>
              <span>{{ currencyFormat(benefit.current_pay) }}</span>
              <span>{{ currencyFormat(benefit.year_to_date) }}</span>
            </div>
            <div class="table-footer bold">
              <h3>Total Benefit</h3>
              <h3>
                NGN{{ currencyFormat(reportsData.benefits.current_pay_sum) }}
              </h3>
              <h3>
                NGN{{ currencyFormat(reportsData.benefits.year_to_date_sum) }}
              </h3>
            </div>
          </div>

          <div>
            <h3 class="bold m-30">Deduction</h3>
            <div
              class="table-info "
              v-for="deduction in reportsData.deductions &&
                reportsData.deductions.data"
              :key="deduction.name"
            >
              <span>{{ deduction.name }}</span>
              <span>{{ currencyFormat(deduction.current_pay) }}</span>
              <span>{{ currencyFormat(deduction.year_to_date) }}</span>
            </div>
            <div class="table-footer bold">
              <h3>Total Deduction</h3>
              <h3>
                NGN{{
                  reportsData.deductions &&
                    currencyFormat(reportsData.deductions.current_pay_sum)
                }}
              </h3>
              <h3>
                NGN{{
                  reportsData.deductions &&
                    currencyFormat(reportsData.deductions.year_to_date_sum)
                }}
              </h3>
            </div>
          </div>
          <div class="pay-table bold">
            <h3>Net Salary</h3>
            <h3>
              NGN{{
                reportsData.net_pay &&
                  currencyFormat(reportsData.net_pay.current_pay)
              }}
            </h3>

            <h3>
              NGN{{
                reportsData.net_pay &&
                  currencyFormat(reportsData.net_pay.year_to_date)
              }}
            </h3>
          </div>
        </div>
      </div>
      <div
        v-if="!isReportAvailable && !loading"
        class="center-text mt-20 small"
      >
        No payslip report available for
        {{ `${months[reportParams.month - 1]} ${reportParams.year}` }}.
      </div>
    </div>
  </div>
</template>

<script>
import {
  tableFormatter,
  currencyFormat,
  tableCurrencyFormat,
} from "@/helpers/functions";
export default {
  data() {
    return {
      selectedFormat: "",
      downloadFormats: [],
      reportsData: {},
      reportParams: {},
      loading: false,
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
    };
  },
  computed: {
    isReportAvailable() {
      return Object.keys(this.reportsData).length;
    },
  },
  mounted() {
    this.reportParams = this.$route.params.reportParams;
    if (!this.reportParams || !Object.keys(this.reportParams).length) {
      this.$notification.error(
        "Please select month and year to generate report for."
      );
      this.$router.push("/ess/payroll/report/generate");
      return;
    }
    this.getEssAttendanceReport();
  },
  methods: {
    currencyFormat,
    tableFormatter,
    tableCurrencyFormat,
    downloadReport() {},
    monthNumToName(monthnum) {
      return this.months[monthnum];
    },
    getEssAttendanceReport() {
      this.loading = true;
      this.$store
        .dispatch("ess/payroll/report/getEssPayslipReport", this.reportParams)
        .then(response => {
          this.loading = false;
          this.reportsData = response.data;
        })
        .catch(error => {
          this.loading = false;
          this.$notification.error(error.message);
        });
    },
  },
};
</script>

<style scoped>
.el-table {
  border: 1px solid #333333;
  border-bottom: none;
  border-top: none;
}
.border-table {
  border: 1px solid #333333;
}
.border {
  border: 2px solid #e0dddda1;
  padding: 30px;
}
.report-head {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.logo {
  width: 100px;
  margin-bottom: 20px;
}
.btn-wrapper {
  margin-left: auto;
}
.table-title {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #16214d;
  padding: 10px;
  color: #ffffff;
  width: 350px;
  margin: auto;
}

.totals {
  background: #16214d;
  color: #ffffff;
}

.gray-text {
  color: #888888;
  font-size: 14px;
}

.table-head {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #16214d;
  color: #ffffff;
  height: 50px;
}
.table-head-info {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
.border-right {
  border-right: 0.5px solid #000000;
  margin-left: 20px;
}
.table-info {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin: 15px 0 15px 30px;
}
.pay-table {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  background: #16214d;
  color: #ffffff;
  padding: 15px 0 15px 30px;
}
.table-footer {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  background: #dadada;
  padding: 15px 0 15px 30px;
}
</style>
